import React from 'react'
import CircularProgress from 'material-ui-legacy/CircularProgress'
import {pinkA200} from 'material-ui-legacy/styles/colors'

const CircularLoader = (props) => (
  <CircularProgress
    mode="indeterminate"
    color={props.color || pinkA200}
    size={props.size}
    style={props.style}
    innerStyle={props.innerStyle}
  />
)

export default CircularLoader



// WEBPACK FOOTER //
// ./src/components/UI/CircularLoader.jsx